@let saving = dialogState.isSaving();

<div class="flex flex-wrap items-center justify-between gap-[0.75rem] border-t border-t-(--p-primary-50) px-[1rem] py-[0.5rem]">
  <p-button [text]="true"
            severity="contrast"
            class="flex"
            styleClass="!h-[2rem] !gap-[0.375rem] !rounded-[0.25rem] !border !border-transparent !bg-(--p-surface-0) !px-[0.4375rem] !py-[0.1875rem] !text-[0.75rem] !font-medium !text-(--p-blue-500) enabled:hover:!border-(--p-blue-100) enabled:hover:!bg-(--p-neutral-500) enabled:active:!border-(--p-blue-500) enabled:active:!bg-(--p-blue-500) enabled:active:!text-(--p-surface-0)"
            [disabled]="saving"
            (onClick)="toggleVisibility()">
    <svg-icon [src]="isHidden() ? 'icons/icon-eye.svg' : 'icons/icon-eye-hide.svg'"
              [name]="isHidden() ? 'icon-eye' : 'icon-eye-hide'"
              class="size-[1.25rem] shrink-0"></svg-icon>

    <span [translate]="isHidden() ? '@@fp-event-footer__unhide' : '@@fp-event-footer__hide'"></span>
  </p-button>
</div>
